import React, { useState, useEffect } from 'react'
import { strCol, numCol, dateTimeCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../../../admin/component/CommonScreen'
import { connect } from 'react-redux'
import { Button, message } from 'antd'
import { getApiTargetInfo, getUserName } from 'core/selectors'
import * as api from '../../../api/pgads'
import moment from 'moment'

const title = 'Message From Administration'

const AdminMessage = ({ apiTargetInfo, userName }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [categoryList, setCategoryList] = useState([])

  useEffect(() => {
    api
      .getMessageCategory(apiTargetInfo)
      .fork(console.log, data => setCategoryList(data))
  }, [apiTargetInfo])

  //   const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
  //     <div
  //       style={{
  //         width: '100%',
  //         display: 'flex',
  //       }}
  //     >
  //       <div
  //         style={{
  //           width: '100px',
  //           display: 'grid',
  //           alignContent: 'center',
  //           marginLeft: '20px',
  //         }}
  //       >
  //         Category :
  //       </div>
  //       <Select
  //         style={{ width: '200px' }}
  //         value={insertData.category}
  //         onChange={e => setInsertData({ ...insertData, category: e })}
  //       >
  //         {categoryList.map(({ category }) => (
  //           <Select.Option key={category}>{category}</Select.Option>
  //         ))}
  //       </Select>
  //       <div
  //         style={{
  //           width: '100px',
  //           display: 'grid',
  //           alignContent: 'center',
  //           marginLeft: '50px',
  //         }}
  //       >
  //         Message :
  //       </div>
  //       <Input
  //         style={{ width: '300px' }}
  //         value={insertData.message}
  //         onChange={e =>
  //           setInsertData({ ...insertData, message: e.target.value })
  //         }
  //         maxLength={15}
  //       />
  //       <Button
  //         type="primary"
  //         style={{ marginLeft: '50px' }}
  //         onClick={() => onAdd(true)}
  //       >
  //         Add
  //       </Button>
  //       <Button
  //         type="primary"
  //         style={{ marginLeft: '50px' }}
  //         onClick={() => onAdd(false)}
  //       >
  //         Add & Hide
  //       </Button>
  //       <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
  //         Cancel
  //       </Button>
  //     </div>
  //   )

  const extraCriteriaAfterButton = ({ onRetrieve, selectedRows }) => {
    return (
      <Button
        type="danger"
        disabled={(selectedRows.selectedRows || []).length <= 0}
        onClick={_ => {
          if ((selectedRows.selectedRows || []).length <= 0) {
            message.info('Please, Select Rows.')
            return
          }
          const selrows = (selectedRows.selectedRows || []).map(d => ({
            ...d,
            ackDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
          }))
          api
            .postAdminMessageAck(apiTargetInfo)(selrows)
            .fork(
              _ => _,
              _ => {
                onRetrieve()
              }
            )
        }}
      >
        Acknowledged
      </Button>
    )
  }

  const sortOnData = data => {
    return data.filter(f => f.username === userName)
  }
  return (
    <CommonScreen
      sortOnData={sortOnData}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={AdminMessageHeaders}
      saveTask={api.saveUserMessage}
      retrieveTask={api.getAdminMessage}
      deleteTask={api.deleteUserMessage}
      autoRetrieve
      sortOptions={AdminMessageHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && false}
      defaultInsertData={{ adminUser: true }}
      onInsertEvent={_ => setInsertEvent(false)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
      withUpdate={false}
      skipValidation
      withoutModify
      allowInsert={false}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  userName: getUserName(state),
})

export default connect(mapStateToProps)(AdminMessage)

export const AdminMessageHeaders = [
  dateTimeCol({
    ident: 'datetime',
    display: 'Date Time',
    sortOrder: 'dsc',
    width: 200,
    isKey: true,
  }),
  numCol({
    ident: 'messageId',
    display: 'Message ID',
    displayFormat: '0',
    isKey: true,
    // alignment: 'right',
    width: 150,
  }),
  dateTimeCol({
    ident: 'ackDate',
    display: 'Acknowledged Date',
    width: 200,
    isKey: true,
  }),
  strCol({
    ident: 'message',
    display: 'Message',
    width: 600,
    alignment: 'left',
    isKey: true,
    ellipsis: true,
  }),
]
